export default __webpack_public_path__ + "static/media/pot4.7282642e.svg";